// Premier Granite LLC — Site data (public, launch-approved content only)

export const site = {
  name: "Premier Granite LLC",
  shortName: "Premier Granite",
  tagline: "Craftsmanship Built to Last. Excellence Set in Stone.",
  phone: "(469) 298-8661",
  phoneHref: "tel:+14692988661",
  email: "info@premiergranite.net",
  emailHref: "mailto:info@premiergranite.net",
  domain: "premiergranite.net",
  url: "https://premiergranite.net",
  serviceArea: "Dallas–Fort Worth Metroplex & Surrounding Cities",
  serviceCities: [
    "Dallas", "Fort Worth", "Plano", "Frisco", "McKinney",
    "Allen", "Prosper", "Arlington", "Irving", "Richardson", "Carrollton"
  ],
  logoLight: "/pg-color.png",
  logoDark: "/pg-white.png",
};

export const nav = [
  { name: "Home", path: "/" },
  { name: "Services", path: "/services" },
  { name: "Materials", path: "/materials" },
  { name: "Gallery", path: "/gallery" },
  { name: "Our Process", path: "/process" },
  { name: "Commercial", path: "/commercial" },
  { name: "About", path: "/about" },
  { name: "FAQ", path: "/faq" },
  { name: "Contact", path: "/contact" },
];

export const materialsNav = [
  { name: "Granite", path: "/materials/granite" },
  { name: "Quartz", path: "/materials/quartz" },
  { name: "Natural Stone", path: "/materials/natural-stone" },
];

export const IMG = {
  heroKitchen: "https://images.unsplash.com/photo-1758448755927-e5c5ae14790c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000&ixlib=rb-4.1.0",
  kitchenDining: "https://images.unsplash.com/photo-1760072513457-651955c7074d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&ixlib=rb-4.1.0",
  kitchenSinkMarble: "https://images.unsplash.com/photo-1772567732983-447c7db0ce4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&ixlib=rb-4.1.0",
  kitchenIsland: "https://images.unsplash.com/photo-1772567732923-5ba1956dcd07?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&ixlib=rb-4.1.0",
  kitchenContemporary: "https://images.pexels.com/photos/6032398/pexels-photo-6032398.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  graniteTexture: "https://images.unsplash.com/photo-1628977614615-f5f4068361ed?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&ixlib=rb-4.1.0",
  stoneWhiteBrown: "https://images.unsplash.com/photo-1721743433271-24cefed2669b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&ixlib=rb-4.1.0",
  stoneGrey: "https://images.unsplash.com/photo-1652205649513-788afff17088?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&ixlib=rb-4.1.0",
  slabs: "https://images.pexels.com/photos/19302430/pexels-photo-19302430.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
  bathroomVanity: "https://images.unsplash.com/photo-1763485956292-7b9bed7b3c10?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&ixlib=rb-4.1.0",
  bathroomLong: "https://images.unsplash.com/photo-1763485956243-50068d04a1ad?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&ixlib=rb-4.1.0",
  bathroomDouble: "https://images.unsplash.com/photo-1770941450515-50f2b8ca380b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&ixlib=rb-4.1.0",
  bathroomConcrete: "https://images.unsplash.com/photo-1763485956070-431fca7bc030?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&ixlib=rb-4.1.0",
  commercialLobby: "https://images.unsplash.com/photo-1758448093806-88b2089068ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&ixlib=rb-4.1.0",
  commercialCounter: "https://images.unsplash.com/photo-1637711805966-c5181f89ddb6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&ixlib=rb-4.1.0",
  fireplaceModern: "https://images.unsplash.com/photo-1772567732985-6fefa2dff56d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&ixlib=rb-4.1.0",
  fireplaceCozy: "https://images.unsplash.com/photo-1762640448649-4eb3b65e67da?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&ixlib=rb-4.1.0",
  install: "https://images.unsplash.com/photo-1723902499865-98918d4dbf7b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&ixlib=rb-4.1.0",
  process: "https://images.pexels.com/photos/33497138/pexels-photo-33497138.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
};

export const trustItems = [
  "Residential & Commercial",
  "Custom Fabrication",
  "Professional Installation",
  "Quality Materials",
];

export const homeMaterials = [
  {
    slug: "granite",
    name: "Granite",
    blurb: "Natural character, durability and timeless appeal.",
    image: IMG.graniteTexture,
  },
  {
    slug: "quartz",
    name: "Quartz",
    blurb: "Consistent design, beautiful finishes and easy everyday maintenance.",
    image: IMG.kitchenSinkMarble,
  },
  {
    slug: "natural-stone",
    name: "Natural Stone",
    blurb: "Distinctive slabs with one-of-a-kind movement and depth.",
    image: IMG.slabs,
  },
];

export const services = [
  {
    slug: "kitchen-countertops",
    title: "Kitchen Countertops",
    blurb: "Custom surfaces designed around the heart of the home.",
    image: IMG.kitchenSinkMarble,
    applications: ["Perimeter counters", "Waterfall edges", "Backsplashes", "Undermount sink cutouts"],
  },
  {
    slug: "kitchen-islands",
    title: "Kitchen Islands",
    blurb: "Statement pieces built for everyday function and visual impact.",
    image: IMG.kitchenIsland,
    applications: ["Seated islands", "Prep islands", "Waterfall islands", "Bar tops"],
  },
  {
    slug: "bathroom-vanities",
    title: "Bathroom Vanities",
    blurb: "Clean, durable stone surfaces tailored to the space.",
    image: IMG.bathroomVanity,
    applications: ["Single & double vanities", "Shower surrounds", "Tub decks", "Custom cutouts"],
  },
  {
    slug: "commercial-projects",
    title: "Commercial Projects",
    blurb: "Stone fabrication and installation for qualifying business and commercial applications.",
    image: IMG.commercialLobby,
    applications: ["Reception surfaces", "Break rooms", "Multifamily", "Hospitality & retail"],
  },
  {
    slug: "custom-stonework",
    title: "Custom Stonework",
    blurb: "Custom fabrication for unique residential and commercial applications.",
    image: IMG.slabs,
    applications: ["Feature walls", "Outdoor kitchens", "Table & desk tops", "Specialty pieces"],
  },
  {
    slug: "fireplaces",
    title: "Fireplaces & Stone Features",
    blurb: "Refined stone surrounds and feature applications that anchor a room.",
    image: IMG.fireplaceModern,
    applications: ["Fireplace surrounds", "Hearths", "Accent features", "Custom facings"],
  },
];

export const processSteps = [
  { step: "01", title: "Consultation", description: "Tell us about your project, your space and what you have in mind." },
  { step: "02", title: "Material Selection", description: "Choose the surface, color and style that fits your project." },
  { step: "03", title: "Measurement & Planning", description: "Project details and dimensions are confirmed before fabrication." },
  { step: "04", title: "Fabrication", description: "Stone is prepared and finished according to the approved project specifications." },
  { step: "05", title: "Installation", description: "The finished surfaces are professionally installed and the project is reviewed." },
];

export const whyUs = [
  { title: "Craftsmanship", description: "Attention to detail from planning through installation." },
  { title: "Quality", description: "Materials and workmanship selected with lasting performance in mind." },
  { title: "Communication", description: "A clear process from estimate through completion." },
  { title: "Experience", description: "Practical stone fabrication and installation knowledge applied to every project." },
];

export const faqs = [
  { question: "Do you offer free estimates?", answer: "Yes. Request a free estimate through our online form or by phone, and a member of our team will follow up regarding next steps." },
  { question: "What areas do you serve?", answer: "We serve the Dallas–Fort Worth (DFW) metroplex and surrounding cities, including Dallas, Fort Worth, Plano, Frisco, McKinney, Allen, Prosper, Arlington, Irving and more." },
  { question: "What materials do you work with?", answer: "We work primarily with granite, quartz and natural stone for countertops, islands, vanities, commercial surfaces and custom stonework." },
  { question: "Do you handle both residential and commercial projects?", answer: "Yes. We provide fabrication and installation for residential homeowners as well as builders, contractors and qualifying commercial projects." },
  { question: "Can you help me choose between granite and quartz?", answer: "Absolutely. We'll discuss how each material looks, performs and is maintained so you can choose the right surface for your space and lifestyle." },
  { question: "Do you install undermount sinks and cooktop cutouts?", answer: "Yes. Cutout work such as undermount sinks and cooktops is part of our fabrication and installation process." },
  { question: "How do I care for my stone surfaces?", answer: "Care depends on the material. We'll share the appropriate care guidance for your specific surface after installation." },
  { question: "Do you work with builders, contractors and designers?", answer: "Yes. We regularly collaborate with builders, contractors and designers on residential and commercial projects." },
];

export const galleryCategories = ["All", "Kitchens", "Islands", "Bathrooms", "Commercial", "Fireplaces", "Custom"];

export const galleryProjects = [
  { id: 1, title: "Marble-Look Kitchen with Island", category: "Kitchens", material: "Quartz", image: IMG.heroKitchen },
  { id: 2, title: "Open-Concept Kitchen", category: "Kitchens", material: "Natural Stone", image: IMG.kitchenDining },
  { id: 3, title: "Contemporary Kitchen", category: "Kitchens", material: "Granite", image: IMG.kitchenContemporary },
  { id: 4, title: "Undermount Sink Detail", category: "Kitchens", material: "Quartz", image: IMG.kitchenSinkMarble },
  { id: 5, title: "Statement Kitchen Island", category: "Islands", material: "Natural Stone", image: IMG.kitchenIsland },
  { id: 6, title: "Floating Stone Vanity", category: "Bathrooms", material: "Quartz", image: IMG.bathroomVanity },
  { id: 7, title: "Double Vanity Suite", category: "Bathrooms", material: "Natural Stone", image: IMG.bathroomDouble },
  { id: 8, title: "Minimal Vanity", category: "Bathrooms", material: "Quartz", image: IMG.bathroomConcrete },
  { id: 9, title: "Reception Desk Surface", category: "Commercial", material: "Natural Stone", image: IMG.commercialLobby },
  { id: 10, title: "Commercial Counter", category: "Commercial", material: "Quartz", image: IMG.commercialCounter },
  { id: 11, title: "Modern Fireplace Surround", category: "Fireplaces", material: "Natural Stone", image: IMG.fireplaceModern },
  { id: 12, title: "Feature Fireplace", category: "Fireplaces", material: "Granite", image: IMG.fireplaceCozy },
  { id: 13, title: "Custom Stone Slabs", category: "Custom", material: "Natural Stone", image: IMG.slabs },
  { id: 14, title: "Custom Countertop Install", category: "Custom", material: "Granite", image: IMG.install },
];

export const materialDetails = {
  granite: {
    name: "Granite",
    hero: IMG.graniteTexture,
    tagline: "Natural character, durability and timeless appeal.",
    intro: "Granite is a natural stone quarried in slabs, so each piece carries its own movement, tone and personality. It's a popular choice for homeowners who want authentic stone with strong everyday performance.",
    appearance: "Natural grains, flecks and veining that vary from slab to slab. No two installations look exactly alike.",
    applications: ["Kitchen countertops & islands", "Bathroom vanities", "Outdoor & specialty surfaces"],
    characteristics: ["Hard, dense natural stone", "Heat-tolerant in everyday use", "Wide range of colors and patterns"],
    maintenance: ["Clean with mild soap and water", "Periodic sealing is recommended", "Avoid harsh or acidic cleaners"],
  },
  quartz: {
    name: "Quartz",
    hero: IMG.kitchenSinkMarble,
    tagline: "Consistent design, beautiful finishes and easy everyday maintenance.",
    intro: "Engineered quartz combines natural quartz with resins to create a non-porous surface with consistent color and pattern. It's a great fit when you want a predictable look with low day-to-day upkeep.",
    appearance: "Consistent patterns and colors, from clean solids to marble-inspired veining.",
    applications: ["Kitchen countertops & islands", "Bathroom vanities", "Commercial surfaces"],
    characteristics: ["Non-porous surface", "Consistent color and pattern", "Broad range of modern finishes"],
    maintenance: ["Clean with soap and water", "No sealing required", "Use trivets for very hot cookware"],
  },
  "natural-stone": {
    name: "Natural Stone",
    hero: IMG.slabs,
    tagline: "Distinctive slabs with one-of-a-kind movement and depth.",
    intro: "Natural stone options such as marble and quartzite offer striking, individual character. These surfaces are ideal for design-forward spaces where a unique statement matters.",
    appearance: "Dramatic veining and depth that make each slab a distinctive feature.",
    applications: ["Feature islands & countertops", "Bathroom vanities", "Accent & specialty surfaces"],
    characteristics: ["Unique, natural veining", "Premium, design-forward appearance", "Varies by stone type and slab"],
    maintenance: ["Use pH-neutral cleaners", "Sealing is recommended", "Wipe spills promptly to protect the surface"],
  },
};

export const projectKinds = ["Residential", "Commercial"];

export const projectTypes = [
  "Kitchen Countertops",
  "Kitchen Island",
  "Bathroom Vanity",
  "Fireplace / Feature",
  "Commercial Surfaces",
  "Custom Stonework",
  "Other",
];

export const materialInterest = ["Granite", "Quartz", "Natural Stone", "Not sure yet"];

export const timelineOptions = [
  "As soon as possible",
  "Within 1 month",
  "1–3 months",
  "3+ months",
  "Just exploring options",
];
